var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarAnimation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 44.9487C88.4308 43.499 87.6193 42.2345 86.5674 41.1826C85.5155 40.1307 84.251 39.3192 82.8013 38.75C84.251 38.1808 85.5155 37.3693 86.5674 36.3174C87.6193 35.2655 88.4308 34.001 89 32.5513C89.5692 34.001 90.3807 35.2655 91.4326 36.3174C92.4845 37.3693 93.749 38.1808 95.1987 38.75C93.749 39.3192 92.4845 40.1307 91.4326 41.1826C90.3807 42.2345 89.5692 43.499 89 44.9487Z",
    stroke: "url(#paint0_linear_187_16227)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; -32 20; 0 0",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1; 2; 1",
    begin: "0s",
    dur: "5s",
    repeatCount: "indefinite",
    additive: "sum"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 64.75C50.3357 64.75 64 51.0857 64 27.25C64 51.0857 77.6643 64.75 101.5 64.75C77.6643 64.75 64 78.4143 64 102.25C64 78.4143 50.3357 64.75 26.5 64.75Z",
    fill: "url(#paint1_linear_187_16227)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 12 30; 20 -30",
    begin: "1s",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1; 0.5; 1",
    begin: "1s",
    dur: "4s",
    repeatCount: "indefinite",
    additive: "sum"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_16227",
    x1: 89,
    y1: 26.75,
    x2: 89,
    y2: 50.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3683FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#9FC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_187_16227",
    x1: 64,
    y1: 27.25,
    x2: 64,
    y2: 102.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3683FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAnimation);
export default __webpack_public_path__ + "static/media/starAnimation.1c07077ab23469dd6f0ea9d68579966e.svg";
export { ForwardRef as ReactComponent };